import { call, put, takeEvery } from "redux-saga/effects"

import { GET_DOCUMENT_REQUESTS, ADD_NEW_DOCUMENT_REQUEST, UPDATE_DOCUMENT_REQUEST, DELETE_DOCUMENT_REQUEST } from "./actionTypes";
import {
    getDocumentRequestsSuccess,
    getDocumentRequestsFail,
    addDocumentRequestSuccess,
    addDocumentRequestFail,
    updateDocumentRequestSuccess,
    updateDocumentRequestFail,
    deleteDocumentRequestSuccess,
    deleteDocumentRequestFail,
   
} from "./actions"

import {
    getDocumentRequests,
    addNewDocumentRequest,
    updateDocumentRequest,
    deleteDocumentRequest,
   
} from "helpers/document-requests/document_requests_backend_helper";
import { toast } from "react-toastify";

function* fetchDocumentRequests() {
    try {
        const response = yield call(getDocumentRequests)

        yield put(getDocumentRequestsSuccess(response))
    } catch (error) {
        yield put(getDocumentRequestsFail(error))
    }
}

function* onAddNewDocumentRequest({ payload }) {
    try {

        
        const response = yield call(addNewDocumentRequest, payload)

        console.log("RESPONSE:", response);
        yield put(addDocumentRequestSuccess(response.documentRequest))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addDocumentRequestFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateDocumentRequest({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateDocumentRequest, payload)
        yield put(updateDocumentRequestSuccess(response.documentRequest))
        toast.success(response.data.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateDocumentRequestFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteDocumentRequest({ payload: data }) {

    try {
        const response = yield call(deleteDocumentRequest, data)
        yield put(deleteDocumentRequestSuccess(response.classRoomId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteDocumentRequestFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* documentRequestSaga() {
    yield takeEvery(GET_DOCUMENT_REQUESTS, fetchDocumentRequests)
    yield takeEvery(ADD_NEW_DOCUMENT_REQUEST, onAddNewDocumentRequest)
    yield takeEvery(UPDATE_DOCUMENT_REQUEST, onUpdateDocumentRequest)
    yield takeEvery(DELETE_DOCUMENT_REQUEST, onDeleteDocumentRequest)
}

export default documentRequestSaga;